import { useEffect } from 'react'
import classNames from 'classnames'
import { TCategoryStocks } from '../types/TCategory'
import StockListingDynamicTable from '../Listing/StocksListingDynamicTable'
import { eventMapping, eventData } from './stock-listing.tracking'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'

interface IListingParent {
  listingData?: TCategoryStocks
  showSidebar?: boolean
}

interface IListing {
  listingData?: TCategoryStocks
  showSidebar?: boolean
}

const INListingParent = ({ listingData, showSidebar }: IListingParent) => {
  const respData = listingData
    ? {
        pageParams: [0],
        pages: [listingData],
      }
    : undefined

  const resultsList = respData?.pages
    .filter(Boolean)
    .flat()
    .map(el => el.data)
    .flat()
    .filter(Boolean)

  const pushEvent = useAnalyticsEvent()

  useEffect(() => {
    const eventAction =
      window.innerWidth < 568 ? 'landed_l1_mweb' : 'landed_l1_dweb'
    pushEvent({ gaPayload: { eventAction, eventCategory: 'landed_on_page' } })
  }, [pushEvent])

  const flatData = respData?.pages.filter(Boolean).flat()

  const columnList1 = flatData?.[0].columnList ?? []
  return (
    <div
      className={classNames('flex flex-1 flex-col', {
        'herolike-wrapper': showSidebar,
      })}
    >
      <StockListingDynamicTable
        columnList1={columnList1}
        resultsList={resultsList}
        isFetchingNextPage={false}
        fetchNextPage={() => null}
        eventsData={{
          listClickEvent: eventMapping[eventData.stocksPopularListClick],
        }}
      />
    </div>
  )
}

const INListingWright = (props: IListing) => <INListingParent {...props} />

export default INListingWright
